import React from 'react';
import ServicePicker from '../ui/servicePicker/ServicePicker';
import { Service } from '../../types/rest/assetCatalogTypes';
import { useDispatch } from 'react-redux';
import { setPageFilter } from '../../store/ui/pageFilters/pageFilterActions';
import BzmIcon from '../icons/BzmIcon';
import { useTranslation } from 'react-i18next';
import SimpleLoader from '../loaders/SimpleLoader';
import HelpTooltip from 'components/overlays/helpTooltip/HelpTooltip';

interface EmptyDataPanelProps {
  onClose(): void;
  isLoading: boolean;
  isError?: boolean;
  onChangeService: (serviceId: number) => void;
  filterServiceIds?: number[];
}

const EmptyDataPanel = (props: EmptyDataPanelProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const selectHandler = (service: Service | null) => {
    if (service) {
      dispatch(
        setPageFilter({
          searchTerm: '',
          serviceId: service.id || -1,
        }),
      );
      props.onChangeService(service.id || -1);
    }
  };

  return (
    <div className={'panel'}>
      <div className={'panel-heading'}>
        <div className={'panel-block panel-block-light'}>
          <div className={'panel-title'}>
            <span className={'h2 align-middle text-uppercase'}>Service Data</span>
            <button onClick={props.onClose} className={'close btn-link ml-2 mt-1'} title="Close Panel">
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
            <HelpTooltip
              className={'icon-xs btn-no-hover float-right mr-3 mt-2'}
              id={'test-data-synthetic-help'}
              title={'Help'}
            />
          </div>
        </div>
      </div>
      <div className={'panel-body'}>
        {!props.isLoading && !props.isError ? (
          <div className={'text-center mt-10 pt-10'}>
            <BzmIcon size={70} className={'text-muted'} variant={'icon-bzm-data-select'} />
            <div className={'h4 pt-4 font-weight-semi-bold'}>{t('servicePicker.selectServicePlaceholder')}</div>
            <div className={'mt-5 mx-5'}>
              <ServicePicker
                isSelectAll={false}
                selectHandler={selectHandler}
                filterServiceIds={props.filterServiceIds}
              />
            </div>
            <div className={'mt-4'}>{t('tdm.serviceNotSelected')}</div>
          </div>
        ) : (
          <div className={'text-center mt-10 pt-10'}>
            <BzmIcon size={70} className={'text-muted'} variant={'icon-bzm-ct-data-parameterization'} />
            <div className={'mt-5 mx-5'}>
              {props.isError ? (
                <div>Failed to load Service Data</div>
              ) : (
                <SimpleLoader loadingText={'Loading Service Data...'} />
              )}
            </div>
          </div>
        )}
      </div>
      <div className={'panel-footer'}>
        <div className={'panel-block panel-block-light panel-block-condensed text-center'}>
          <div className={'font-size-sm'}>
            <strong>Hint:</strong> How do I define test data?
            <i style={{ fontStyle: 'initial' }} className={'js-define-test-data-help btn-link ml-2'}>
              See Help
            </i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyDataPanel;
